import { Button, Form, Input, InputNumber, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import { addEducation } from "../../education/educationApis";
import { getAllMaster } from "../../../redux/rtk/features/masters/masterSlice";

const EducationAddSinglePopup = ({ setLoading }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const user_id = useParams("id");
  const dispatch = useDispatch();
  const qualificationTypes =
    useSelector((state) => state.masters?.masters?.QualificationTypeMaster) ||
    [];
  useEffect(() => dispatch(getAllMaster()), []);
  const onFinish = async (values) => {
    setLoader(true);
    setLoading(true);
    const infodata = {
      ...values,
	  EmployeeQualificationsId:0,
      EmployeeId: parseInt(user_id.id),
      DataStatus: 1,
    };

    const resp = await addEducation(infodata);

    if (resp.message === "success") {
      setLoader(false);
      dispatch(loadSingleStaff(user_id.id));
      setIsModalOpen(false);
      setLoading(false);
      form.resetFields();
    } else {
      setLoader(false);
      setLoading(false);
      toast.error("Failed to add qualification");
    }
  };

  const onFinishFailed = () => {
    toast.warning("Failed at adding qualification");
    setLoader(false);
    setLoading(false);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setLoader(false);
    setLoading(false);
    form.resetFields();
  };

  return (
    <>
      <div className="text-center">
        <Button type="primary" onClick={showModal}>
          Add New Qualification
        </Button>
      </div>
      <Modal
        title="Add Qualification"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          name="addQualification"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 16 }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Qualification Type"
            name="QualificationTypeId"
            rules={[
              {
                required: true,
                message: "Please select a qualification type!",
              },
            ]}
          >
            <Select placeholder="Select qualification type" allowClear>
              {qualificationTypes.map((type) => (
                <Select.Option
                  key={type.QualificationTypeId}
                  value={type.QualificationTypeId}
                >
                  {type.QualificationTypeName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Institution"
            name="InstitutionName"
            rules={[
              { required: true, message: "Please input the institution name!" },
            ]}
          >
            <Input placeholder="Enter institution name" />
          </Form.Item>

          <Form.Item
            label="Year of Passing"
            name="YearOfPassing"
            rules={[
              { required: true, message: "Please input the year of passing!" },
            ]}
          >
            <InputNumber
             
            />
          </Form.Item>

          <Form.Item
            label="Grade/Percentage"
            name="GradeOrPercentage"
            rules={[
              {
                required: true,
                message: "Please input the grade or percentage!",
              },
            ]}
          >
            <Input placeholder="Enter grade or percentage" />
          </Form.Item>

          <Form.Item
            label="Field of Study"
            name="FieldOfStudy"
            rules={[
              { required: true, message: "Please input the field of study!" },
            ]}
          >
            <Input placeholder="Enter field of study" />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 6, span: 12 }}>
            <Button type="primary" htmlType="submit" block loading={loader}>
              Add Now
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EducationAddSinglePopup;
